import { useAppFeatures } from "@/hooks/useAppFeatures";

import AdvancedDataWeightPanel from "./AdvancedDataWeightPanel";
import LegacyDataWeightPanel from "./LegacyDataWeightPanel";
import SimpleDataWeightPanel from "./SimpleDataWeightPanel";
import { useDataWeightSettings } from "./useDataWeightSettings";

interface Props {
  onClose: () => void;
}

/**
 * Data Weight settings popup. All state, computed values, and handlers come
 * from useDataWeightSettings (called once here) and are passed down to the
 * panels as props. Picks the panel layout: legacy when the advanced-options
 * feature flag is OFF, otherwise simple/advanced based on the current mode.
 */
const DataWeightSettingsPopupV2 = ({ onClose }: Props) => {
  const { isAdvanceDataWeightOptionsEnabled } = useAppFeatures();
  const settings = useDataWeightSettings();
  const {
    state: { mode }
  } = settings;

  if (!isAdvanceDataWeightOptionsEnabled) {
    return <LegacyDataWeightPanel {...settings} onClose={onClose} />;
  }

  if (mode === "simple") {
    return <SimpleDataWeightPanel {...settings} onClose={onClose} />;
  }

  return <AdvancedDataWeightPanel {...settings} onClose={onClose} />;
};

export default DataWeightSettingsPopupV2;
